/**
 * GOOGLE BAĞLANTISINI BAŞLAT — tek kullanımlık bilet akışı.
 *
 * Doğrudan /api/google/connect?domainId=... adresine gitmek güvensizdi: o uç tarayıcı
 * yönlendirmesiyle açıldığı için oturum başlığı taşıyamıyor, dolayısıyla kimliği
 * doğrulanmıyordu. Üçüncü biri kurbana kendi domainId'siyle hazırlanmış bir link
 * gönderip KURBANIN Google jetonlarını kendi hesabına yazdırabiliyordu.
 *
 * Artık: oturumlu uçtan bilet alınır (sunucu domain sahipliğini doğrular), sonra
 * dönen tek kullanımlık adrese yönlenilir.
 */
export async function startGoogleConnect(domainId: number, returnTo?: string): Promise<void> {
  const res = await fetch("/api/google/connect-ticket", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ domainId, returnTo: returnTo ?? "" }),
  });
  const body = (await res.json().catch(() => ({}))) as { url?: string; error?: string };
  if (!res.ok || !body.url) throw new Error(body.error ?? "Google bağlantısı başlatılamadı");
  window.location.href = body.url;
}
